const stats = [
  { value: '18+', label: 'лет практики' },
  { value: '100+', label: 'корпоративных проектов' },
  { value: '450+', label: 'тренингов' },
  { value: '4500+', label: 'участников' },
];

const industries = [
  'Логистика',
  'E-commerce и импорт',
  'Консьерж-услуги',
  'Недвижимость',
  'EdTech',
  'B2B-услуги',
];

const countries = ['Беларусь', 'Россия', 'Казахстан', 'Израиль'];

export default function SocialProof() {
  return (
    <section className="py-12 md:py-16 bg-white border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-6">
        <p className="text-center text-xs md:text-sm font-semibold uppercase tracking-widest text-gray-400 mb-8">
          Со мной развивали команды компании из разных отраслей и стран
        </p>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 mb-10 max-w-4xl mx-auto">
          {stats.map((s) => (
            <div key={s.label} className="text-center">
              <div className="text-2xl md:text-4xl font-extrabold text-teal-600 mb-1">{s.value}</div>
              <div className="text-xs md:text-sm text-gray-500">{s.label}</div>
            </div>
          ))}
        </div>

        <div className="flex flex-wrap justify-center gap-2 mb-5">
          {industries.map((i) => (
            <span
              key={i}
              className="bg-teal-50 text-teal-800 border border-teal-100 px-3 py-1.5 rounded-full text-xs font-medium"
            >
              {i}
            </span>
          ))}
        </div>

        <p className="text-center text-xs md:text-sm text-gray-500">
          Работал с командами: {countries.join(' · ')}. Средняя оценка участников — 9,09/10.
        </p>
      </div>
    </section>
  );
}